import { useQueryClient } from '@tanstack/react-query';
import useApiMutation from '_api/mutations/useApiMutation';
import { GET_UNREAD_MESSAGES } from '_api/queries/message';
import { Message } from '_api/types';

export const MARK_MESSAGE_READ = 'mark-message-read';

export const useMarkMessageRead = () => {
  const queryClient = useQueryClient();
  return useApiMutation<Message, { messageId: number }>(
    ({ messageId }) => `/message/${messageId}/read`,
    'put',
    {},
    {
      mutationKey: [MARK_MESSAGE_READ],
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [GET_UNREAD_MESSAGES] });
      },
    },
  );
};
